import React, { useState, useRef, useEffect } from "react";
import { Plus } from "lucide-react";
import { cryptiqueAnalyticsTheme as theme } from "../theme";
import AddToBoardDropdown from "./AddToBoardDropdown";

/**
 * "+ Add content" block shown between board blocks (Mixpanel-style).
 * Opens dropdown to add Text, Image, Chart, or Media at this position.
 */
export default function AddContentBlock({ insertIndex, onSelect, disabled }) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleSelect = (id) => {
    setOpen(false);
    onSelect?.(id, insertIndex);
  };

  return (
    <div className="py-3 flex justify-start">
      <div ref={anchorRef} className="relative inline-flex items-center">
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpen((prev) => !prev);
          }}
          disabled={disabled}
          className="flex items-center gap-1.5 py-1.5 px-0 rounded text-sm transition-colors border-0 bg-transparent cursor-pointer"
          style={{
            color: theme.textMuted,
            fontFamily: "Raleway, sans-serif",
          }}
          onMouseEnter={(e) => {
            if (!disabled) {
              e.currentTarget.style.color = theme.primaryLight;
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = theme.textMuted;
          }}
        >
          <Plus className="w-4 h-4 flex-shrink-0" strokeWidth={2} />
          <span>Add content</span>
        </button>
        <AddToBoardDropdown
          open={open}
          onClose={() => setOpen(false)}
          anchorRef={anchorRef}
          onSelectType={handleSelect}
        />
      </div>
    </div>
  );
}
